import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import bgImage from "../assets/gallery/team all/15augteampic.jpg";
import "../styles/Careers.scss";

const Careers = () => {
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    position: "",
    coverLetter: "",
  });
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleApplyClick = () => setShowForm(true);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    setTimeout(() => {
      navigate("/");
    }, 3000);
  };

  return (
    <section className="careers-section " id="careers">
      <div className="careers-hero">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              {!showForm && !submitted && (
                <motion.div
                  className="hero-content text-center section-padding"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  <h2 className="section-title">Join Our Team</h2>
                  <p className="section-subtitle">
                    We are always looking for passionate and talented individuals to
                    join our growing team. If you want to contribute to innovative
                    projects and be part of a dynamic environment, we want to hear
                    from you!
                  </p>
                  <button
                    onClick={handleApplyClick}
                    className="btn btn-primary btn-lg apply-btn d-flex mx-auto"
                    style={{ maxWidth: '200px' }}
                  >
                    Apply Now
                  </button>
                </motion.div>
              )}

              {showForm && !submitted && (
                <motion.div
                  className="form-container"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="row justify-content-center my-5">
                    <div className="col-lg-8">
                      <div className="application-form mt-0">
                        <div className="form-header">
                          <h3 className="form-title ">Job Application Form</h3>
                          <div className="form-divider"></div>
                        </div>

                        <form onSubmit={handleSubmit}>
                          <div className="form-grid text-start">
                            <div className="form-group">
                              <label className="form-label">
                                <span className="label-text">Full Name</span>
                                <span className="required">*</span>
                              </label>
                              <div className="input-wrapper">
                                <input
                                  type="text"
                                  name="name"
                                  value={formData.name}
                                  onChange={handleChange}
                                  className="form-control"
                                  placeholder="Enter your full name"
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-group">
                              <label className="form-label">
                                <span className="label-text">Email</span>
                                <span className="required">*</span>
                              </label>
                              <div className="input-wrapper">
                                <input
                                  type="email"
                                  name="email"
                                  value={formData.email}
                                  onChange={handleChange}
                                  className="form-control"
                                  placeholder="Enter your email address"
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-group full-width">
                              <label className="form-label">
                                <span className="label-text">Position Applying For</span>
                                <span className="required">*</span>
                              </label>
                              <div className="input-wrapper">
                                <input
                                  type="text"
                                  name="position"
                                  value={formData.position}
                                  onChange={handleChange}
                                  className="form-control"
                                  placeholder="e.g. Solar Engineer, Project Manager"
                                  required
                                />
                              </div>
                            </div>

                            <div className="form-group full-width">
                              <label className="form-label">
                                <span className="label-text">Cover Letter</span>
                                <span className="required">*</span>
                              </label>
                              <div className="input-wrapper">
                                <textarea
                                  name="coverLetter"
                                  value={formData.coverLetter}
                                  onChange={handleChange}
                                  className="form-control textarea"
                                  rows="5"
                                  placeholder="Tell us why you want to join our team and what makes you a great fit..."
                                  required
                                />
                              </div>
                            </div>
                          </div>

                          <div className="form-footer">
                            <button type="submit" className="btn btn-primary btn-lg submit-btn">
                              <span className="btn-text">Submit Application</span>
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </motion.div>
              )}

              {submitted && (
                <motion.div
                  className="success-message text-center"
                  initial={{ opacity: 0, scale: 0.9 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.5 }}
                >
                  <div className="success-icon">🎉</div>
                  <h3 className="success-title">Thank you for applying!</h3>
                  <p className="success-text">Our HR team will contact you soon.</p>
                  <a
                    href="https://wa.me/919000000000"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-success btn-lg whatsapp-btn"
                  >
                    Chat on WhatsApp
                  </a>
                </motion.div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Careers;